import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { StoresProvider, useStores } from './contexts/StoresContext';
import { pickDefaultStore } from './utils/storeUtils';
import MainPage from './pages/MainPage';
import GoodPage from './pages/GoodPage';
import BadPage from './pages/BadPage';
import AddressesPage from './pages/AddressesPage';
import Q02Page from './pages/Q02Page';
import './App.css';

const RouterWithStores = () => {
  const { loading, stores } = useStores();

  if (loading) return null;
  const def = pickDefaultStore(stores);

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${def}`} replace />} />
      <Route path="/addresses" element={<AddressesPage />} />
      <Route path="/:storeCode" element={<MainPage />} />
      <Route path="/:storeCode/good" element={<GoodPage />} />
      <Route path="/:storeCode/bad"  element={<BadPage  />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/q02" element={<Q02Page />} />
          <Route path="*" element={
            <StoresProvider>
              <RouterWithStores />
            </StoresProvider>
          } />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
